import React from 'react'
import { useLocation } from 'react-router-dom'
import FetchStatus from '../../data/FetchStatus'
import { PageDefinition } from '../../data/types'
import Page from '../Page'
import fetchPageData from '../../data/fetchPageData'

const DEFAULT_FILENAME = 'default'

const ComposedPage = () => {
  const { pathname, search } = useLocation()
  /**
   * remove leading slash from subpath and find the the data file under /cms-data/,
   * e.g. https://welcome.neontv.co.nz/ridge => /cms-data/ridge.json
   * e.g. https://welcome.neontv.co.nz/example/example1 => /cms-data/example/example1.json
   */
  const filename = pathname.replace(/^\/+/, '')
  const [data, fetchStatus] = fetchPageData<PageDefinition>(
    filename === '' ? DEFAULT_FILENAME : filename
  )

  if (
    fetchStatus === FetchStatus.Initial ||
    fetchStatus === FetchStatus.Fetching
  ) {
    return <div>Loading...</div>
  }

  if (fetchStatus === FetchStatus.Error || !data) {
    window.location.href = '//www.neontv.co.nz'
    return null
  }

  // when `isPublic` is false and no "preview=sky" in URL param, hide the screen
  const searchParams = new URLSearchParams(search)
  const isPreviewSky = searchParams.get('preview')?.toLowerCase() === 'sky'
  if (!data.isPublic && !isPreviewSky) {
    return (
      <div>
        This page is not public, please specify correct preview parameter in the
        URL..
      </div>
    )
  }

  return <Page definition={data} />
}

export default ComposedPage
